module.exports = {"350926100":"双城镇","350926101":"富溪镇","350926200":"城郊乡","350926201":"乍洋乡","350926202":"东源乡","350926203":"黄柏乡","350926204":"宅中乡","350926205":"楮坪乡","350926206":"英山乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350926.json
// module id = 1355
// module chunks = 0